import { render, staticRenderFns } from "./AdministratorList.vue?vue&type=template&id=0c6b7a66&"
import script from "./AdministratorList.vue?vue&type=script&lang=js&"
export * from "./AdministratorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports